import { useLocalStorage as useReactUseLocalStorage } from 'react-use';
import { useCallback, Dispatch, SetStateAction } from 'react';
import { isFromApp } from 'utils/isFromApp';
import { dispatchStorageEvent } from 'utils/storage';

type parserOptions<T> =
  | {
      raw: true;
    }
  | {
      raw: false;
      serializer: (value: T) => string;
      deserializer: (value: string) => T;
    };

export function useLocalStorage<T>(key: string, initialValue?: T, options?: parserOptions<T>) {
  const [state, setItem, removeItem] = useReactUseLocalStorage(key, initialValue, options);

  const set: Dispatch<SetStateAction<T | undefined>> = useCallback(
    (valOrFunc) => {
      setItem(valOrFunc);

      if (isFromApp) {
        dispatchStorageEvent();
      }
    },
    [setItem]
  );

  const remove = useCallback(() => {
    removeItem();

    if (isFromApp) {
      dispatchStorageEvent();
    }
  }, [removeItem]);

  return [state, set, remove] as const;
}
